/* eslint-disable */
import dotize from "./Dotize.js";
import moment from "moment";

export default class AbstractService {
  constructor(httpService) {
    this.http = httpService;
  }

  // API calls functions
  findAll(query, include, embed, page, perPage, field, ascending) {
    const q = Object.assign({}, query);
    const params = this.getParams(
      q,
      include,
      embed,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url("/"), {
      params
    });
  }

  findByReference(reference, include, embed) {
    let data = this.http.get(this.url(`/${reference}`), {
      params: {
        include: include ? this.arrayToParams(include) : undefined,
        embed: embed || undefined
      }
    });
    return data;
  }

  update(model) {
    return this.http.put(this.url(`/${model.reference}`), model);
  }

  deleteOne(modelReference) {
    return this.http.delete(this.url(`/${modelReference}`));
  }

  create(model) {
    return this.http.post(this.url("/"), model);
  }

  delete(model) {
    return this.http.delete(this.url(`/${model.reference}`));
  }

  updateMany(list) {
    return this.http.put(this.url("/"), list);
  }

  patch(reference, model) {
    return this.http.patch(this.url(`/${reference}`), model);
  }

  // Utilitary functions
  getParams(query, include, embed, page, perPage, field, ascending) {
    const dotized = dotize.convert(query);
    for (const queryParamter in dotized) {
      if (dotized[queryParamter] === "") {
        delete dotized[queryParamter];
      }
    }
    return Object.assign({}, dotized, {
      include: include ? this.arrayToParams(include) : undefined,
      embed: embed || undefined,
      page: page || undefined,
      limit: perPage || undefined,
      sort: field || undefined,
      ascending
    });
  }

  arrayToParams(array) {
    let result = "";
    let i = 0;
    if (!array.includes("reference")) {
      array.push("reference");
    }
    for (const param of array) {
      if (i > 0) {
        result += ",";
      }
      result += param;
      i++;
    }
    return result;
  }

  findFromModel(
    model,
    include,
    page,
    perPage,
    field,
    ascending,
    gridColumnsFields
  ) {
    [include, field] = this.fromListToParams(include, field, gridColumnsFields);
    let params = this.getParams(
      this._modelToQuery(model),
      include,
      null,
      page,
      perPage,
      field,
      ascending
    );
    return this.http.get(this.url("/"), {
      params: params
    });
  }

  fromListToParams(include, field, gridColumnsFields) {
    include = include.map(field => {
      return field.value;
    });
    if (field && gridColumnsFields) {
      field = gridColumnsFields.find(obj => {
        return obj.title === field;
      }).value;
    }
    return [include, field];
  }

  toDayRange(date) {
    return `range|(${moment(date).startOf("day")},${moment(date).endOf(
      "day"
    )})`;
  }

  selectedDateRange(start, end) {
    return `range|(${moment(start).startOf("day")},${moment(end).endOf(
      "day"
    )})`;
  }

  builInQuery(value) {
    return `in|${value.reduce(
      (accumulator, currentValue) => `${accumulator},${currentValue}`
    )}`;
  }
}
